import React from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { Button } from "../../../common/Button/Button";
import moment from "moment";
import { NavButtons } from "../../../common/NavButtons/NavButtons";
import NotesTrailDropdown from "./NotesTrailDropdown";
import CheckboxContainer from "../../../common/CheckboxContainer/CheckboxContainer";

export default function AssignServicePartnerModal(props) {
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent>
      <div className="p-2 modal-header-bar">
						<span>Assign Service Partner</span>
						<button
							type="button"
							className="close"
							aria-label="Close"
							onClick={() => props.toggleModal(!props.isOpen)}
						>
							<X
								style={{ pointerEvents: "none" }}
								color="white"
							/>
						</button>
					</div>{" "}
        <div
          className="m-3 "
          style={{ overflowY: "scroll", maxHeight: "400px" }}
        >
          <CheckboxContainer
            toggleSelection={props.toggleServicePartner}
            checkboxItemsList={props.servicePartnerList}
          />
        </div>
        <div style={{ margin: "5px 20px" }}>
          <Button onClick={props.saveServicePartner}>Save</Button>
          <span className="ml-2 cursor-pointer" onClick={props.toggleModal}>
            Cancel
          </span>
        </div>
      </ModalContent>
    </Modal>
  );
}
